import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { CacheService } from 'mapfre-auditlib';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class WorkService {

  className = 'WorkService';

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  /**
 *  Work Origin
 */

  getAllOriginWorks(cache = true, cacheKey = "allOriginWorks"): Observable<any[]>| any {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<any[]>(environment.base_URL + "/origin").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newOriginWork(work) {
    return this.http.post(environment.base_URL + "/origin", work)
  }

  updateOriginWork(work, id) {
    return this.http.put(environment.base_URL + `/origin/${id}`, work)
  }

  /**
   *  Work types
   */

  getAllWorkTypes(cache = true, cacheKey = "allWorkTypes"): Observable<any[]>| any {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<any[]>(environment.base_URL + "/jobs/type").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newWorkType(work) {
    return this.http.post(environment.base_URL + "/jobs/type", work)
  }

  updateWorkType(work, id) {
    return this.http.put(environment.base_URL + `/jobs/type/${id}`, work)
  }

  /**
 *  Work Status
 */

  getAllWorkStatus(cache = true, cacheKey = "allWorkStatus"): Observable<any[]>| any {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<any[]>(environment.base_URL + "/jobs/state").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newWorkStatus(work) {
    return this.http.post(environment.base_URL + "/jobs/state", work)
  }

  updateWorkStatus(work, id) {
    return this.http.put(environment.base_URL + `/jobs/state/${id}`, work)
  }

  /**
  *  Work Reason Cancel 
  */

  getAllWorkReasons(cache = true, cacheKey = "allWorkReasonsClose"): Observable<any[]> | any {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<any[]>(environment.base_URL + "/jobs/reason-close").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newWorkReason(work) {
    return this.http.post(environment.base_URL + "/jobs/reason-close", work)
  }

  updateWorkReason(work, id) {
    return this.http.put(environment.base_URL + `/jobs/reason-close/${id}`, work)
  }
}
